import { ARJIV_EMAIL_URL } from "Common";
import Heading from "Components/Heading";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { updateMetaTags } from "utility/utils";

function Policies() {
  useEffect(() => {
    updateMetaTags({
      title: "Arjiv Exports Application Policy",
      description:
        "Learn about Arjiv Exports Application Usage Policy",
      keywords:
        "App policy",
      canonical: "https://www.arjivexports.com/app_policy",
    });
  }, []);

  return (
    <div className="main-content policy bg-primary text-offwhite font-poppins">
      <div className="container mx-auto px-4 sm:pt-8 pt-5 max-w-6xl">
        <Heading className="uppercase tracking-wide text-center md:mb-12 mb-6">Arjiv Exports Application Usage Policy</Heading>
        <div className="sm:mb-10 mb-7">
          <p className="sm:text-[16px] text-sm text-justify leading-relaxed">
            Arjiv Exports built the Arjiv Exports app as a Free app. This
            SERVICE is provided by Arjiv Exports at no cost and is intended for
            use as is.
          </p>
          <p className="sm:text-[16px] text-sm text-justify leading-relaxed">
            If you choose to use our Service, then you agree to the collection
            and use of information in relation to this policy. The Personal
            Information that we collect is used for providing and improving the
            Service. We will not use or share your information with anyone
            except as described in this Privacy Policy.
          </p>
          <p className="sm:text-[16px] text-sm text-justify leading-relaxed">
            The terms used in this Privacy Policy have the same meanings as in
            our Terms and Conditions, which are accessible at Arjiv Exports
            unless otherwise defined in this Privacy Policy.
          </p>
        </div>

        <div className="sm:mb-10 mb-7">
          <h2 className="sm:text-3xl text-2xl sm:mb-4 mb-3 font-poppins font-medium">
            Information Collection and Use
          </h2>
          <p className="sm:text-[16px] text-sm text-justify leading-relaxed">
             For a better experience, while using our Service, we may require you
            to provide us with certain personally identifiable information,
            including but not limited to Full Name, Email ID, Mobile Number. The
            information that we request will be retained by us and used as
            described in this privacy policy. The app does use third-party
            services that may collect information used to identify you.
          </p>
        </div>

        <div className="sm:mb-10 mb-7">
          <h2 className="sm:text-3xl text-2xl sm:mb-4 mb-3 font-poppins font-medium">
            Policy – Due Diligence
          </h2>
          <p className="sm:text-[16px] text-sm text-justify leading-relaxed">
            The company shall always undertake to ensure that the extraction and
            trade of diamond support peace and development, not conflict. Arjiv
            Exports remains committed to enhance its Supply Chain Due Diligence
            program through internal review and external assessments. We have
            zero tolerance policy for the supplier violating OECD due diligence
            guideline and we shall immediately stop commercial relationship if
            any of our business associates found non-compliant or High-Risk
            during our internal/external risk assessment. Currently Arjiv
            Exports procure it’s precious metals from RJC-CoC and CoP compliant
            miners/refiners/traders. However, we have established a strong due
            diligence process and we shall review it as an when we observed
            significant risk or upon receipt of any grievance or complaint but
            in normal course, we shall carry our due diligence process on annual
            basis.
          </p>
          <p className="sm:text-[16px] text-sm text-justify leading-relaxed">
            Link to the privacy policy of third-party service providers used by
            the app:
          </p>
          <p className="sm:text-[16px] text-sm text-justify leading-relaxed">
            - Google Play Services,
          </p>
          <p className="sm:text-[16px] text-sm text-justify leading-relaxed">
            - Google Analytics for Firebase,
          </p>
          <p className="sm:text-[16px] text-sm text-justify leading-relaxed">
           - Firebase Crashlytics
          </p>
        </div>

        <div className="sm:mb-10 mb-7">
          <h2 className="sm:text-3xl text-2xl sm:mb-4 mb-3 font-poppins font-medium">
           Log Data
          </h2>
          <p className="text-justify leading-relaxed">
            We want to inform you that whenever you use our Service, in a case
            of an error in the app we collect data and information (through
            third-party products) on your phone called Log Data. This Log Data
            may include information such as your device Internet Protocol (“IP”)
            address, device name, operating system version, the configuration of
            the app when utilizing our Service, the time and date of your use of
            the Service, and other statistics.
          </p>
        </div>

        <div className="sm:mb-10 mb-7">
          <h2 className="sm:text-3xl text-2xl sm:mb-4 mb-3 font-poppins font-medium">
           Cookies
          </h2>
          <p className="text-justify leading-relaxed">
            Cookies are files with a small amount of data that are commonly used
            as anonymous unique identifiers. These are sent to your browser from
            the websites that you visit and are stored on your device's internal
            memory.
          </p>
          <p className="text-justify leading-relaxed">
            This Service does not use these “cookies” explicitly. However, the
            app may use third-party code and libraries that use “cookies” to
            collect information and improve their services. You have the option
            to either accept or refuse these cookies and know when a cookie is
            being sent to your device. If you choose to refuse our cookies, you
            may not be able to use some portions of this Service.
          </p>
        </div>

        <div className="sm:mb-10 mb-7">
          <h2 className="sm:text-3xl text-2xl sm:mb-4 mb-3 font-poppins font-medium">
           Service Providers
          </h2>
          <p className="text-justify leading-relaxed">
            We may employ third-party companies and individuals due to the
            following reasons:
          </p>
          <p className="text-justify leading-relaxed">- To facilitate our Service;</p>
          <p className="text-justify leading-relaxed">- To provide the Service on our behalf;</p>
          <p className="text-justify leading-relaxed">- To perform Service-related services; or</p>
          <p className="text-justify leading-relaxed">- To assist us in analysing how our Service is used.</p>
          <p className="text-justify leading-relaxed">
            We want to inform users of this Service that these third parties
            have access to their Personal Information. The reason is to perform
            the tasks assigned to them on our behalf. However, they are
            obligated not to disclose or use the information for any other
            purpose.
          </p>
        </div>

        <div className="sm:mb-10 mb-7">
          <h2 className="sm:text-3xl text-2xl sm:mb-4 mb-3 font-poppins font-medium">
           Security
          </h2>
          <p className="text-justify leading-relaxed">
            We value your trust in providing us your Personal Information, thus
            we are striving to use commercially acceptable means of protecting
            it. But remember that no method of transmission over the internet,
            or method of electronic storage is 100% secure and reliable, and we
            cannot guarantee its absolute security.
          </p>
        </div>

        <div className="sm:mb-10 mb-7">
          <h2 className="sm:text-3xl text-2xl sm:mb-4 mb-3 font-poppins font-medium">
           Links to Other Sites
          </h2>
          <p className="text-justify leading-relaxed">
            This Service may contain links to other sites. If you click on a
            third-party link, you will be directed to that site. Note that these
            external sites are not operated by us. Therefore, we strongly advise
            you to review the Privacy Policy of these websites. We have no
            control over and assume no responsibility for the content, privacy
            policies, or practices of any third-party sites or services.
          </p>
        </div>

        <div className="sm:mb-10 mb-7">
          <h2 className="sm:text-3xl text-2xl sm:mb-4 mb-3 font-poppins font-medium">
           Children’s Privacy
          </h2>
          <p className="text-justify leading-relaxed">
            These Services do not address anyone under the age of 13. We do not
            knowingly collect personally identifiable information from children
            under 13 years of age. In the case we discover that a child under 13
            has provided us with personal information, we immediately delete
            this from our servers. If you are a parent or guardian and you are
            aware that your child has provided us with personal information,
            please contact us so that we will be able to do the necessary
            actions.
          </p>
        </div>

        <div className="sm:mb-10 mb-7">
          <h2 className="sm:text-3xl text-2xl sm:mb-4 mb-3 font-poppins font-medium">
           Changes to This Privacy Policy
          </h2>
          <p className="text-justify leading-relaxed">
            We may update our Privacy Policy from time to time. Thus, you are
            advised to review this page periodically for any changes. We will
            notify you of any changes by posting the new Privacy Policy on this
            page.
          </p>
        </div>

        <div className="sm:mb-10 mb-7">
          <h2 className="sm:text-3xl text-2xl sm:mb-4 mb-3 font-poppins font-medium">
           Contact Us
          </h2>
          <p className="text-justify leading-relaxed">
            If you have any questions or suggestions about our Privacy Policy,
            do not hesitate to contact us at{" "}
            <Link
                to={ARJIV_EMAIL_URL}
                className="text-blue-400 text-lg underline"
            >
                surat@arjiv.com
            </Link>
          </p>
        </div>
        {/* Date */}
        <div className="bg-gray-100 py-3 text-center"></div>
      </div>
    </div>
  );
}

export default Policies;
